interface ButtonProps {
    onClick: () => void;
    icon: string;
    text: string;
    tabIndex: number;
    className: string;
  }
  export const Button = (props: ButtonProps) => {
    const { onClick, icon, text, tabIndex, className } = props;
    return (
        <div
            className={`primary_button ${className} text-white rounded-xl`}
            role="button"
            tabIndex={tabIndex}
            onClick={onClick}
          >
            <div className="button_icon">
              <img
                src={icon}
                alt={text}
                width={30}
                height={30}
              />
            </div>
            <div className="text-white">{text}</div>
          </div>
    //   <button
    //     className="w-[230px] flex flex-row gap-4 items-center text-white bg-black px-3 py-2 border-white border-5"
    //     onClick={onClick}
    //   >
    //     <img className="w-9 h-9" src={icon} alt={text} />
    //     {text}
    //   </button>
    );
  };